import {useState, useCallback} from 'preact/hooks';
import _ from 'lodash';

import {scrollToAim} from '~/utils';
import poster from '~/assets/qianfan/banner-bg.png';
import {Swiper, SwiperSlide} from 'swiper/react';
import {linkArrow} from '../comp/commonCom';
import hot from '~/assets/qianfan/banner-hot.svg';
import {banner} from '~/locals/qianfan/index';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';
const mp4 = 'https://aip-static.cdn.bcebos.com/landing/product/qianfan_mb_banner.mp4';
const {cardList} = banner;

const swiperConfig = {
    direction: 'vertical',
    parallax: true,
    slidesPerView: 1,
    loop: true,
    speed: 800,
    observer: true,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    spaceBetween: 0
};

const bannerSwiperConfig = {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    observer: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    },
    simulateTouch: false,
    spaceBetween: 0
};

const id = 'qianfan-banner';

const SlideBannerQf = ({slide, idx}) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const {noticeList, title, title_m, title_ipad, desc, className, id, frameworkIcon, btns, titleFs} = slide;
    const onSlideChange = useCallback(swiper => {
        setCurrentIndex(swiper.realIndex);
    }, []);

    return (
        <div className={`banner-info-wrapper ${className}`}>
            <div className="banner-info">
                <div className="banner-text">
                    <div>
                        {noticeList ? (
                            <div className="notice no_rem-notice carousel-wrapper">
                                <a
                                    href={noticeList[currentIndex].link}
                                    rel="noopener noreferrer"
                                    className="notice-link"
                                    target="_blank"
                                    {...noticeList[currentIndex].trackInfo}
                                >
                                    <span className="tag-container">
                                        {noticeList.map((notice, index) => (
                                            <span
                                                className={`tag no_rem_fs_16 ${index === currentIndex ? 'active' : ''}`}
                                            >
                                                <img src={hot} alt="tag" className="hot-img" />
                                                <span style={{fontWeight: 600}}>{notice.tag}</span>
                                            </span>
                                        ))}
                                    </span>
                                    {_.size(noticeList) > 1 ? (
                                        <Swiper
                                            {...swiperConfig}
                                            onSlideChange={onSlideChange}
                                            className="notice-swiper-wrapper"
                                        >
                                            {noticeList.map((notice, index) => {
                                                return (
                                                    <SwiperSlide key={index}>
                                                        <span className="desc no_rem_fs_16">{notice.desc}</span>
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                    ) : (
                                        <span className="desc no_rem_fs_16">{noticeList[0].desc}</span>
                                    )}
                                    <span className="arrow no_rem_fs_16">{linkArrow}</span>
                                </a>
                            </div>
                        ) : null}
                        <h2 className={`banner-title ${titleFs}`}>
                            <span className="banner-title-gradual">{title}</span>
                        </h2>
                        <h2 className={`banner-title-ipad ${titleFs}`}>
                            <span className="banner-title-gradual">{title_ipad}</span>
                        </h2>
                        <h2 className={`banner-title-mobile ${titleFs}`}>{title_m}</h2>
                        <p className={`banner-desc ${titleFs}`}>{desc}</p>
                        <p className="banner-desc-mobile">{desc}</p>
                        <div className="banner-btns">
                            {btns
                                ? btns.map(btn => (
                                      <a
                                          href={btn.href}
                                          {...btn.trackInfo}
                                          rel="noopener noreferrer"
                                          className={btn.cn}
                                          target="_blank"
                                      >
                                          {btn.text}
                                      </a>
                                  ))
                                : null}
                        </div>
                    </div>
                </div>
                <div className="banner-framework">
                    <div className="framework-wrapper">
                        <img src={frameworkIcon} alt="架构图" />
                    </div>
                </div>
                {/* {id === 1 ? (
                    <div className="banner-framework banner-framework-mb" style={{visibility: 'hidden'}}>
                        <div className="framework-wrapper">
                            <img src={framework} alt="架构图" />
                        </div>
                    </div>
                ) : (
                    <div className="banner-framework">
                        <div className="framework-wrapper">
                            <img src={frameworkIcon} alt="架构图" />
                        </div>
                    </div>
                )}
                {id === 1 ? (
                    <div className="ab-framework-wrapper">
                        <img src={frameworkMb} alt="架构图" />
                    </div>
                ) : null} */}
            </div>
        </div>
    );
};
const Banner = () => {
    const [bannerIndex, setBannerIndex] = useState(0);
    useCptDuration(id, {
        name: `${applicationName}-banner-停留时长`
    });

    const onBannerSlideChange = useCallback(swiper => {
        setBannerIndex(swiper.realIndex);
    }, []);

    return (
        <div className="qf-banner no_rem_qf_banner" id="qianfan-banner">
            <video muted autoPlay loop poster={poster} playsinline="true" webkit-playsinline="true">
                <source src={mp4} type="video/mp4" />
            </video>
            <div className="banner-container-wrapper">
                <div className="banner-container">
                    <Swiper
                        {...bannerSwiperConfig}
                        className="banner-swiper-wrapper"
                        onSlideChange={onBannerSlideChange}
                    >
                        {banner.slideLists.map(slide => {
                            return (
                                <SwiperSlide>
                                    <SlideBannerQf slide={slide} idx={bannerIndex} />
                                </SwiperSlide>
                            );
                        })}
                        <div className="swiper-pagination swiper-pagination-banner" />
                    </Swiper>

                    <div className="card-list">
                        {cardList.map((item, index) => (
                            <div
                                className={`card-item card-item${index}`}
                                key={item.id}
                                {...item.trackInfo}
                                onClick={() => {
                                    const selectItem = document.getElementById(item.id);
                                    scrollToAim(selectItem, item.offset);
                                }}
                            >
                                <div className="card-header">
                                    <span className="card-icon">
                                        <img src={item.icon} alt="icon" />
                                    </span>
                                    <h3 className="card-title">{item.title}</h3>
                                </div>
                                <p className="card-content no_rem_fs_16">{item.content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
